import * as React from 'react';
import { ArticleHeading2, Image } from '@cian/ui-kit';
import cn from 'classnames';

import * as styles from './styles.css';

interface IProps {
  firstLetter?: string | null;
  circle?: boolean;
  url?: string | null;
  width?: number;
  height?: number;
}

export const _PreviewImg: React.FC<IProps> = ({ url, circle, width, height, firstLetter }: IProps) => {
  // oxlint-disable-next-line react/rules-of-hooks
  const imageNode = React.useMemo(() => {
    if (!url && firstLetter) {
      return (
        <ArticleHeading2 color="gray40_100" data-testid="LetterImg">
          {firstLetter}
        </ArticleHeading2>
      );
    }

    return <Image src={url || ''} borderRadius={circle ? '50%' : '4px'} objectFit="cover" />;
  }, [circle, firstLetter, url]);

  return (
    <div
      data-testid="PreviewImg"
      className={cn(styles['img'], circle ? styles['circle'] : styles['square'])}
      style={{
        width,
        height,
      }}
    >
      {imageNode}
    </div>
  );
};

export const PreviewImg = React.memo(_PreviewImg);
